/* ==========================================================================
   LUJE — keep the "Only N left" line in step with the selected variant.

   The Liquid renders the currently selected variant's state server-side, so
   the line is already correct on load and with JavaScript off. This only keeps
   it honest when the shopper switches size, by reading the per-variant counts
   the snippet emitted and re-writing the text.

   It watches the hidden `name="id"` input the product form keeps up to date,
   rather than binding to swatch clicks. That input is the single thing every
   variant-selection path on this theme has to update — swatches, dropdowns,
   deep links with ?variant=, and the browser back button — so watching it
   catches all of them without knowing how any of them work.
   ========================================================================== */
(function () {
  'use strict';

  function init(root) {
    var box = (root || document).querySelector('[data-luje-lowstock]');
    if (!box || box.__lujeWired) return;

    var dataEl = document.querySelector('[data-luje-lowstock-data]');
    var input = document.querySelector('form[action*="/cart/add"] input[name="id"], input[name="id"]');
    if (!dataEl || !input) return;

    var counts;
    try { counts = JSON.parse(dataEl.textContent || '{}'); } catch (e) { return; }

    box.__lujeWired = true;

    var textEl = box.querySelector('[data-luje-lowstock-text]');
    var threshold = parseInt(box.getAttribute('data-threshold'), 10) || 2;
    var oneTpl = box.getAttribute('data-one') || '';
    var manyTpl = box.getAttribute('data-many') || '';

    function render() {
      var qty = counts[String(input.value)];
      var show = typeof qty === 'number' && qty > 0 && qty <= threshold;

      if (!show) {
        box.classList.add('luje-lowstock--empty');
        textEl.textContent = '';
        return;
      }
      // `count` is the placeholder Shopify's `t` filter leaves in the string.
      textEl.textContent = qty === 1 ? oneTpl : manyTpl.replace(/\{\{\s*count\s*\}\}/g, qty);
      box.classList.remove('luje-lowstock--empty');
    }

    // The form rewrites the input's value rather than firing an event we can
    // rely on, so watch the attribute and the property both.
    new MutationObserver(render).observe(input, { attributes: true, attributeFilter: ['value'] });
    input.addEventListener('change', render);
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('.product-options, .product__variant-picker')) {
        setTimeout(render, 60);
      }
    }, true);
    window.addEventListener('popstate', function () { setTimeout(render, 60); });

    render();
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  init(document);

  // Quick view and other injected product markup arrive later.
  new MutationObserver(function () { init(document); })
    .observe(document.documentElement, { childList: true, subtree: true });
})();
